import React from 'react';
import { Toaster } from 'react-hot-toast';
import { AppProvider } from './providers/app';
import { AppRoutes } from './routes';
import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/css/fontawesome.css';

const App = () => {
	return (
		<AppProvider>
			<Toaster />
			<AppRoutes />
		</AppProvider>
	);
};

export default App;
